__turbopack_context__.v({
  "backButtonWrapper": "Layout-module-scss-module__q7otJG__backButtonWrapper",
  "contact": "Layout-module-scss-module__q7otJG__contact",
  "content": "Layout-module-scss-module__q7otJG__content",
  "copyright": "Layout-module-scss-module__q7otJG__copyright",
  "footer": "Layout-module-scss-module__q7otJG__footer",
  "header": "Layout-module-scss-module__q7otJG__header",
  "info": "Layout-module-scss-module__q7otJG__info",
  "infoItem": "Layout-module-scss-module__q7otJG__infoItem",
  "inner": "Layout-module-scss-module__q7otJG__inner",
  "left": "Layout-module-scss-module__q7otJG__left",
  "logo": "Layout-module-scss-module__q7otJG__logo",
  "logoLink": "Layout-module-scss-module__q7otJG__logoLink",
  "wrap": "Layout-module-scss-module__q7otJG__wrap",
});
